import audioFile from '../components/assets/screenpop-notification.mp3'

const makeNotification = (message, type, hasRemindersTier2) => {
  let title = null
  let icon = null
  let body = null
  const requireInteraction = true
  const messageProvided = !!message.message

  switch (type) {
    case 'call': {
      title = 'Incoming call'
      icon = 'https://i.imgur.com/eE3MBke.png'
      body = message.body
      break
    }
    case 'text': {
      if (!messageProvided) {
        body = ''
        icon = 'https://i.imgur.com/8XicUwF.png'
      } else {
        body = message.message.media_url ? '1 attachment' : message.message.body
        icon =
          hasRemindersTier2 && !!message.message.media_url
            ? message.message.media_url
            : 'https://i.imgur.com/8XicUwF.png'
      }

      title = `New text from ${message.patient_name}`
      break
    }
    case 'email': {
      title = `New email from ${message.patient_name}`
      icon = 'https://i.imgur.com/djWVZJF.png'
      body = message.message ? `Subject: ${message.message.subject}` : ''
      break
    }
    default:
      return null
  }
  return new Notification(title, {
    icon,
    body,
    requireInteraction,
  })
}

export default (
  {
    props: {
      setFilter,
      searchPatients,
      updatePatientsAllLocations,
      setCurrentConvoFromNotification,
      setConversationType,
      convoMsgTypeFilter,
      updateConvoMessageTypeFilter,
      updateConversationDetails,
      hasRemindersTier2,
      history,
      newContactInfo,
      togglePopover,
    },
  },
  message,
  type,
) => {
  const audio = new Audio(audioFile)
  audio.play()
  const notification = makeNotification(message, type, hasRemindersTier2)

  notification.onclick = () => {
    window.focus()

    if (type === 'call') {
      if (message.is_known_to_practice) {
        updatePatientsAllLocations(true)
        setFilter('all', 'filters', 'list')
        searchPatients(message.phone_number)
        history.push('/patients')
      } else {
        newContactInfo('phoneNumber', message.phone_number)
        togglePopover('enterContactInfo')
        history.push('/calls')
      }
    } else if (type === 'text' || type === 'email') {
      if (!['all', type].includes(convoMsgTypeFilter)) {
        updateConvoMessageTypeFilter(type)
        updateConversationDetails(message.conversation)
      }
      setCurrentConvoFromNotification(message.conversation.id)
      setConversationType(type)
      history.push('/messages')
    }
    notification.close()
  }
  setTimeout(notification.close.bind(notification), 10000)
}



// WEBPACK FOOTER //
// ./src/services/notification-helpers.js